var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import Box from "../Grid/Box";
import Text from "../Text/Text";
/**
 * A text spanning multiple lines.
 * @param {object} props
 * @param {string} props.text The text to split into multiple lines.
 * @param {import('../Text/textVariants').TextVariants} [props.variant]
 */
export default function MultilineText(_a) {
    var { text, variant } = _a, rest = __rest(_a, ["text", "variant"]);
    if (!text)
        return null;
    return (_jsx(Box, Object.assign({}, rest, { children: text.split("\n").map((line, index) => (_jsx(Text, { variant: variant, children: line }, index))) })));
}
//# sourceMappingURL=MultilineText.js.map